import React from "react"
import Snackbar from "@material-ui/core/Snackbar"
import store from "../store"
/**
 * Component for displaying errors and other notifactions to the user
 * by popping up on the screen (currently close to the top of the browser window)
 */
export default function SnackBars( ) {
  var autoCloseDelay=6000
  store.useRerenderIfChange(store=>[store.snackBars])

  function handleClose(index) {
    store.snackBars[index].open = false
    store.updateStore()
  }

  // any snack bars triggered are generated here
  // but they are only visible while their `open` property is still set to `true`
  return <>
    {store.snackBars.map(({ open, message, variant }, index) => {
      let closeSnackBar = () => { } // default: do nothing if no close handler is specified
      if (open && typeof handleClose === "function") {
        // assign close handler to listen for user manually closing the snack bar
        closeSnackBar = () => handleClose(index)
        // if a timeout delay is set, automatically close the snack bar after that interval has elapsed
        if (typeof autoCloseDelay === "number" && autoCloseDelay >= 0) {
          setTimeout(closeSnackBar, autoCloseDelay)
        }
      }
      return <Snackbar
        key={index + message}
        open={open}
        message={message}
        variant={variant}
        onClose={closeSnackBar}
      />
    })}
  </>

}
